import React, { useContext, useEffect, useState } from 'react';
import CornerTypes from '../common/CornerTypes';
import ColorListBox from '../ColorsListBody';
import SummaryBar from '../SummaryBar';
import { connect } from 'react-redux';
import { WardrobesConfigsContext } from '../../contexts/WardrobesConfigsContext';
import { ActiveWardrobeContext } from '../../contexts/ActiveWardrobeContext';
import { WardrobeHeightContext } from '../../contexts/WardrobeHeightContext';
import { GAContext } from 'contexts/GAContext';

import { PriceContext } from '../../contexts/PriceContext';
import calculatePrice from '../../helpers/calculatePrice';

const CornerWardrobeBodyConfig = props => {
  const { activeCorner, cornerHulls, productTypesCorners } = props;

  const { wardrobesConfigs, setWardrobesConfigs } = useContext(WardrobesConfigsContext);
  const { activeWardrobe } = useContext(ActiveWardrobeContext);
  const { wardrobeHeight } = useContext(WardrobeHeightContext);
  const { setPrice } = useContext(PriceContext);
  const { GA } = useContext(GAContext);

  const cornerIndex = wardrobesConfigs.findIndex(config => config.is_corner === true);

  const [bodyState, setBodyState] = useState({
    color: null,
    colorsList: [],
    type:
      wardrobesConfigs[cornerIndex] !== undefined
        ? wardrobesConfigs[cornerIndex].dimensions.x === 97
          ? 10
          : wardrobesConfigs[cornerIndex].dimensions.x === 66
          ? 9
          : wardrobesConfigs[cornerIndex].dimensions.x === 103
          ? 11
          : activeCorner
        : null,
    activeMat: null,
  });

  const wardrobe = wardrobesConfigs[activeWardrobe];
  const wardrobeSafo = wardrobe.safo.split('-').pop();

  const setFilter = (value, index) => {
    let params = { ...bodyState };

    if (index === 'color') {
      params.color = value.safo.split('-').pop();
    } else {
      params.color = params.activeMat.split('-').pop();
      params.type = value;
    }

    let filteredData = [...cornerHulls];
    filteredData = filteredData.filter(item => {
      return item.dimensions.y === wardrobeHeight && item.types.hasOwnProperty(params.type);
    });
    params.colorsList = filteredData;
    let newActiveMat = filteredData.find(item => {
      return item.safo.split('-').pop() === params.color;
    });

    if (index === 'color') {
      newActiveMat = {
        ...newActiveMat,
        accessories: wardrobe.accessories,
        fronts: wardrobe.fronts,
        handles: wardrobe.handles,
      };
    }

    if (newActiveMat !== undefined) {
      newActiveMat.defaultFronts = props.defaultFront[8];
      params.activeMat = newActiveMat.safo;
      wardrobesConfigs[activeWardrobe] = newActiveMat;
      setWardrobesConfigs(wardrobesConfigs);
    }

    setBodyState(params);
    setPrice(calculatePrice(wardrobesConfigs[activeWardrobe]));
  };

  const setMaterial = value => {
    GA('Wardrobe Body', 'SelectBody');
    setFilter(value, 'color');
  };

  const setCornerType = value => {
    setFilter(value.id, 'type');
  };

  const myCornerType = [];

  cornerHulls.filter(item => {
    if (item.safo.includes(wardrobeSafo) && item.dimensions.y === wardrobe.dimensions.y) {
      productTypesCorners.filter(el => {
        if (item.types[Object.keys(item.types).pop()] === el.name) {
          myCornerType.push(el);
        }
      });
    }
  });

  useEffect(() => {
    let params = { ...bodyState };
    params.activeMat = wardrobe.safo;
    params.color = wardrobe.code;

    if (wardrobe.types.hasOwnProperty(9)) {
      params.type = 9;
    } else if (wardrobe.types.hasOwnProperty(10)) {
      params.type = 10;
    } else if (wardrobe.types.hasOwnProperty(11)) {
      params.type = 11;
    }

    if (params.colorsList.length === 0) {
      let colorsList = [...cornerHulls];

      colorsList = colorsList.filter(item => {
        return (
          item.dimensions.x === wardrobe.dimensions.x &&
          item.dimensions.y === wardrobe.dimensions.y &&
          item.dimensions.z === wardrobe.dimensions.z &&
          item.types.hasOwnProperty(params.type)
        );
      });

      params.colorsList = colorsList;
    }
    setBodyState(params);
    /* eslint-disable-next-line */
  }, [activeWardrobe, cornerHulls, bodyState.activeMat]);

  return (
    <>
      <div className="container wardrobe-config">
        <CornerTypes
          cornerTypes={myCornerType}
          activeCorner={bodyState.type}
          changeCornerType={setCornerType}
          activeValue={bodyState.activeMat}
        />
        <ColorListBox
          title={`Kolor Korpusu: ${wardrobesConfigs[activeWardrobe].name}`}
          activeValue={bodyState.activeMat}
          changeMaterial={setMaterial}
          colorsList={bodyState.colorsList}
          propClass="color-list--small-margin-bottom"
        />
        <span className="wardrobe-config__info">
          Wnętrze szafy oraz wyposażenie dodatkowe występuje w kolorystyce szare płótno
        </span>
        <SummaryBar
          btnText="Przejdź dalej"
          btnLink="/wardrobe-fronts-configuration"
          btnIcon={true}
        />
      </div>
    </>
  );
};

const mapStateToProps = state => {
  return {
    productTypesCorners: state.productTypes.productTypesCorners,
    cornerHulls: state.products.cornerHulls,
    defaultFront: state.defaults.front,
  };
};

export default connect(mapStateToProps, null)(CornerWardrobeBodyConfig);
